import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withHandlers, lifecycle } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { addProgramRequest, resetCodeError } from '../../redux/reducers/addProjectCode';
import { toggleAddProgrammePopup, toggleNotification } from '../../redux/reducers/view';

import ProjectCodeField from './ProjectCodeField';

import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBAlert, MDBIcon } from "mdbreact";

import { commonStyles } from '../../styles/styles';
import { getUserProgramsFullRequest } from '../../redux/reducers/userProgramsFull';

const AddCodeForm = ({ classes, handleSubmit, handleSubmitAddCode, addProgram }) => (
  <form style={{paddingTop:10}} onSubmit={handleSubmit(handleSubmitAddCode)} className="formPopup">
    <Field
      name="Code"
      component={ProjectCodeField}
      confirmButton={false}
      id="adornment-project-code"
      showLabel={false}
    />
    {addProgram.error && <MDBAlert color="danger" dismiss >
          <MDBIcon icon="exclamation-circle" /><strong> Error!</strong> {addProgram.error}
          </MDBAlert>}
    <MDBBtn 
        right
        size="md"
        className='mt-5 btn-green'
        style={{float:'right'}}
        action
        type="submit">
      SUBMIT
    </MDBBtn>

  </form>
);

const styles = () => ({
  ...commonStyles,
  button: {
    width: 100,
  },
});

const mapStateToProps = state => ({
  form: state.form,
  addProgram: state.addProgramReducer,
});

const mapDispatchToProps = dispatch => ({
  addProgramRequest: () => dispatch(addProgramRequest()),
  toggleAddProgrammePopup: value => dispatch(toggleAddProgrammePopup(value)),
  resetCodeError: () => dispatch(resetCodeError()),
  toggleNotification: value => dispatch(toggleNotification(value)),
  getUserProgramsFullRequest: value => dispatch(getUserProgramsFullRequest(value)),
});

export default compose(
  reduxForm({
    form: 'addCodeForm',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.resetCodeError();
    },
    componentWillReceiveProps(nextProps) {
      if (nextProps.addProgram.isProgramCodeValid) {
        this.props.toggleAddProgrammePopup(false);
        this.props.toggleNotification({
          value: true,
          message: 'Program  was added successfully',
          type: 'success',
        });
       this.props.getUserProgramsFullRequest()
      }
    },
  }),
  withHandlers({
    handleSubmitAddCode: props => () => {
      props.addProgramRequest();
    },
  }),
  withStyles(styles),
)(AddCodeForm);

AddCodeForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  handleSubmitAddCode: PropTypes.func,
  addProgram: PropTypes.instanceOf(Object),
};
